import React, { useEffect, useState } from "react";
import { Route, useNavigate } from "react-router-dom";

const ProtectedRoute = (props) => {

    const navigate = useNavigate();

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const checkUserToken = () => {
        
        const userToken = localStorage.getItem('user-token');
        let userData = localStorage['user-data'];
        
        if (!userToken || userToken === 'undefined') {
            setIsLoggedIn(false);
            return navigate('/auth/login');
        }else{
            if(!userData || userData === 'undefined'){
                setIsLoggedIn(false);
                return navigate('/auth/login');
                
            }else{
                let data = JSON.parse(userData);
                if((data.iat + (3*24*60*60))*1000 < Math.floor(Date.now())){
                    //cek kalau login sudah 3 hari
                    setIsLoggedIn(false);
                    localStorage.clear();
                    return navigate('/auth/login');
                }
            }
            
        }
        setIsLoggedIn(true);
    }

    useEffect(() => {
        let interval = null;
        //init cek token
        checkUserToken();

        //loop cek token
        interval = setInterval(() => {
            checkUserToken();
        }, 1000 * 60 ); // Update every 1 second (1000ms)
        
    }, [isLoggedIn]);

    return (
        <React.Fragment>
            {
                isLoggedIn ? props.children : null
            }
        </React.Fragment>
    );
}

export default ProtectedRoute;